import React from 'react';
import { Modal } from "reactstrap";
import PropTypes from 'prop-types';

const CenterModal = ({ isOpen, toggle, setModal, title,children }) => {
  return (
    <Modal isOpen={isOpen} toggle={toggle} centered style={{ maxWidth: '800px' }}
    >
      <div className="modal-header">
        <h5 className="modal-title mt-0">{title}</h5>
        <button type="button" onClick={toggle}
         className="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div className="modal-body">
        {children}
      </div>
    </Modal>
  );
};
CenterModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
  setModal: PropTypes.func,
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};
export default CenterModal;